/* 我的-运营主体 */
export default [
  {
    path: 'mine/operateMain',
    name: 'operateMain',
    meta: {
      title: '运营主体',
    },
    component: () => import('@/views/mine/operateMain.vue')
  },
  {
    path: 'mine/UserList',
    name: 'mineUserList',
    meta: {
      title: '会员中心',
      isShowTab: true,
      keepAlive: false,
    },
    component: () => import('@/views/mine/UserList.vue')
  },
  {
    path: 'mine/setting',
    name: 'mineSetting',
    meta: {
      title: '设置',
    },
    component: () => import('@/views/mine/setting.vue')
  },
]